import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { useUsuarioStore } from "@/store/usuarioStore";
import KeycloakService from "@/core/services/KeycloakService";
import MensagemService from "@/core/services/MensagemService";

import { auth } from "./auth/index";
import { dashaboard } from "./dashboard/index";
import { pais } from "./pais/index";
import { material_escolar } from "./material-escolar";
import { apoio_gerencial_gestao_de_classe } from "./apoio-gerencial-gestao-de-classe";
import { relatorios } from "./relatorios";
import { informacao_complementar } from "./informacao-complementar";
import { manutencao_de_matriculas } from "./manutencao-de-matriculas";
import { solicitacoes_de_servicos_de_uma_unidade_para_outra } from "./solicitacoes-de-servicos-de-uma-unidade-para-outra";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      ...material_escolar,
      ...apoio_gerencial_gestao_de_classe,
      ...relatorios,
      ...informacao_complementar,
      ...manutencao_de_matriculas,
      ...solicitacoes_de_servicos_de_uma_unidade_para_outra,
    ],
  },
  dashaboard,
  pais,
  ...auth,
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

function validarAutorizacao(to, permissions) {
  if (to.meta.requireAuth === false) {
    return true;
  }

  if (!KeycloakService.getInstance().authenticated) {
    window.location.href = process.env?.VUE_APP_REDIRECT_LOGIN || "";
  }

  if (!to.meta.allowedPermissions) {
    return true;
  }

  if (!Array.isArray(to.meta.allowedPermissions)) {
    return false;
  }

  if (to.meta.allowedPermissions.some((item) => permissions.includes(item))) {
    return true;
  }

  return false;
}

router.beforeEach(async (to, from, next) => {
  //reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  const usuarioStore = useUsuarioStore();
  if (!usuarioStore.dadosCarregados) {
    try {
      await usuarioStore.carregarDadosUsuario();
    } catch (error) {
      console.error("Erro ao carregar dados do usuário:", error);
    }
  }

  const storedMenuData: string = localStorage.getItem("menuData") || "";
  const permissions = Object.values(JSON.parse(storedMenuData)).flat();

  if (validarAutorizacao(to, permissions)) {
    next();
  } else {
    MensagemService.erro({
      texto: "Você não tem permissão para acessar este recurso!",
      confirmButtonText: "OK",
    });
  }

  //Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
